export const ActionTypes = {
  FETCH_ALL: 'services/department/fetch_all',
  FETCH_ALL_SUCCESS: 'services/department/fetch_all_success',
  SET_LOADER_STATUS: 'services/department/set_loader_status',
  SET_ALL: 'services/department/set_all',
  ADD_OR_UPDATE_DEPARTMENT: 'services/department/add_or_update_department',
  DELETE_DEPARTMENT: 'services/department/delete_department',
};

const fetchAll = ({ departmentParams }) => ({
  departmentParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allDepartment }) => ({
  allDepartment,
  type: ActionTypes.SET_ALL,
});

const addorUpdateDepartment = ({
  departmentData,
  actionName,
  departmentParams,
}) => ({
  departmentData,
  actionName,
  departmentParams,
  type: ActionTypes.ADD_OR_UPDATE_DEPARTMENT,
});

const deleteDepartment = ({ id, departmentParams }) => ({
  id,
  departmentParams,
  type: ActionTypes.DELETE_DEPARTMENT,
});

export default {
  fetchAll,
  setAll,
  setLoader,
  addorUpdateDepartment,
  deleteDepartment,
};
